/** Up to this many x labels every label is drawn; beyond it about LABEL_TARGET are, counted from the end. */
export const MAX_ALL_LABELS = 31;
export const LABEL_TARGET = 24;

/**
 * The x label formatter of the ticket sales chart: every label is drawn up to MAX_ALL_LABELS
 * buckets; beyond that (hour spans) only every step-th label is, counted from the last bucket, so
 * the last label ("Doors close") always shows. The bucket is looked up from the label itself, not
 * from the index Apex passes as its third argument: a bar chart's category axis is converted to a
 * numeric one (`convertedCatToNumeric`) and Apex then calls the formatter through a wrapper that
 * hands it the label alone, so on a Bar chart that index is always undefined.
 */
export function thinnedLabelFormatter(categories: string[]): (value: string | number) => string {
  const count = categories.length;
  if (count <= MAX_ALL_LABELS) return (value) => String(value);
  const step = Math.ceil(count / LABEL_TARGET);
  const indexOf = new Map(categories.map((label, i) => [label, i]));
  return (value) => {
    const label = String(value);
    const i = indexOf.get(label);
    if (i === undefined) return label;
    return (count - 1 - i) % step === 0 ? label : '';
  };
}
